// extracted by mini-css-extract-plugin
export default {"Container":"Subtitle_Container__aVbLh","SubtitleArea":"Subtitle_SubtitleArea__qTsIw","Cinema":"Subtitle_Cinema__jnS3j"};